'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const clamp = (val, min, max) => {
  return Math.max(min, Math.min(val, max));
};

exports.clamp = clamp;
//# sourceMappingURL=clamp.cjs.js.map
